import { render, staticRenderFns } from "./ClientChatPage.vue?vue&type=template&id=ee3da77c&scoped=true"
import script from "./ClientChatPage.vue?vue&type=script&lang=js"
export * from "./ClientChatPage.vue?vue&type=script&lang=js"
import style0 from "./ClientChatPage.vue?vue&type=style&index=0&id=ee3da77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee3da77c",
  null
  
)

export default component.exports